<template>
    <tr>
        <td>
            <dl class="row no-gutters text-xs mb-0">
                <dt :class="'col-md-' + labelCol" class="fw-normal text-muted">{{ name }}</dt>
                <dd :class="'col-md-' + (12 - labelCol) + ' text-' + valueAlign" class="mb-0"><slot></slot></dd>
            </dl>
        </td>
    </tr>
</template>

<script>
    export default {
        name: 'Row',
        props: {
            name: {
                required: true
            },
            valueAlign: {
                type: String,
                default: 'left'
            },
            labelCol: {
                type: Number,
                default: 4
            }
        }
    }
</script>
